import { ApiProperty } from '@nestjs/swagger';
import { IsBoolean, IsNotEmpty, IsNumber, IsOptional, IsString } from 'class-validator';

export class ToggleMedioPagoDto {
  @ApiProperty({ description: 'ID del medio de pago' })
  @IsString()
  @IsNotEmpty()
  medio_pago_id: string;

  @ApiProperty({ description: 'Estado activo/inactivo', example: true })
  @IsBoolean()
  activo: boolean;

  @ApiProperty({ description: 'Orden de visualización', example: 0, required: false })
  @IsOptional()
  @IsNumber()
  orden?: number;
}

export class BulkToggleMedioPagoDto {
  @ApiProperty({ description: 'Lista de medios de pago a actualizar', type: [ToggleMedioPagoDto] })
  medios: ToggleMedioPagoDto[];
}
